import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateVoicePolicy } from 'API/VoicePolicies/updateVoicePolicy';

const useUpdateVoicePolicy = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const update = async (voicePolicyData) => {
        const response = await updateVoicePolicy(voicePolicyData);
        return response.data;
    };

    return useMutation({
        mutationFn: update,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['VoicePolicies'] });
            queryClient.invalidateQueries({
                queryKey: ['VoicePolicy', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateVoicePolicy;
